import { initTier3NotCheckout } from '@/pages/_shared/not-checkout/tier3'
import { initPageTier } from '@/pages/_shared/tier-utils'
import { initializeAnalytics } from '@/catalog/product-analytics'
import { showEasyrecRecommendations } from '@/catalog/product-show-easyrec-recommendations'
import { trackEasyrecView } from '@/catalog/product-track-easyrec-view'

export const initTier3 = async (): Promise<void> => {
  await initPageTier(3, [
    initTier3NotCheckout,
    initializeAnalytics,
    async (): Promise<void> => {
      showEasyrecRecommendations()
      trackEasyrecView()
    }
  ])
}
